var swatchesRow = document.querySelector('.product_swatch');
if (swatchesRow) {
    document.addEventListener('change', function (e) {
        var el = e.target;
        if (el.classList.contains('product_swatch_radio')) {
            var val = el.value;
            var optionDropdownId = el.getAttribute('data-selectid');
            var parent = el.closest('.product__info-container');
            if (parent) {
                var optionDropdown = parent.querySelector('#' + optionDropdownId);
                if (optionDropdown) {
                    optionDropdown.value = val;
                    optionDropdown.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            }
        }
    });

}
var doubleButton = document.querySelector('.double-button');
if (doubleButton) {
    document.addEventListener('click', function (e) {
        var el = e.target;
        if (el.classList.contains('double-button') || el.closest('.double-button')) {
            if (!el.classList.contains('double-button')) {
                el = el.closest('.double-button');
            }
            e.preventDefault();
            el.querySelector('form').dispatchEvent(new Event('submit', {
                bubbles: true
            }));
        }
    });
}

var thumbGallery = document.querySelectorAll('.product__thumb-list .product__thumb-item');
if (thumbGallery.length) {
    thumbGallery.forEach(function (item, index) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            var itemId = this.getAttribute('data-media-id');
            var prevActiveThumb = this.parentNode.querySelector('.active_thumb');
            if (prevActiveThumb) {
                prevActiveThumb.classList.remove('active_thumb');
            }
            this.classList.add('active_thumb');
            var mainGalleryItems = document.querySelectorAll('.product__media-wrapper .product__media-item');
            if (mainGalleryItems.length) {
                mainGalleryItems.forEach(function (media, index) {
                    var mediaElId = media.getAttribute('data-mediaId');
                    if (itemId == mediaElId) {
                        var parent = media.parentElement;
                        parent.prepend(media);
                    }
                });
            }
        });
    });
}

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            let checkVariant = document.querySelector('.sale-flag.product_tag_icon');
            if (variant.compare_at_price) {
                if (checkVariant) {
                    document.querySelector('.sale-flag.product_tag_icon').style.display = 'block';
                }

            } else {
                if (checkVariant) {
                    document.querySelector('.sale-flag.product_tag_icon').style.display = 'none';
                }
            }
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        const parent = newMedia.parentElement;
        parent.prepend(newMedia);

        var product_parent = parent.closest('.product');
        var featured_mediaID = this.currentVariant.featured_media.id;

        if (product_parent) {
            var thumbGallery = product_parent.querySelectorAll('.product__thumb-list .product__thumb-item');
            if (thumbGallery.length) {
                thumbGallery.forEach(function (item, index) {
                    var itemId = item.getAttribute('data-media-id');

                    if (featured_mediaID == itemId) {
                        item.classList.add('active_thumb');

                    } else {
                        item.classList.remove('active_thumb');
                    }
                });
            }
        }

        window.setTimeout(() => {
            parent.scroll(0, 0)
        });
    }

    updateURL() {
        if (!this.currentVariant) return;
        //         window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');

            // ??
            if (this.currentVariant.id == 41432154112057) {
                input.value = 40363289706553;

            } else if (this.currentVariant.id == 41432154079289) {
                input.value = 40363289739321;

            } else {
                input.value = this.currentVariant.id;
            }

            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));

        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&#${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) destination.innerHTML = source.innerHTML;

                document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');

                if (this.getAttribute('data-coming-soon') == 'true') {
                    this.toggleAddButton(!this.currentVariant.available, window.strings.coming_soon);
                } else {
                    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
                }

                // Updated additional product price for HiRise 3 + PlugBug Slim
                if (document.querySelector(".hirise-3-wireless-select")) {
                    let selectElement = document.querySelector(".hirise-3-wireless-select"),
                        selectedOption = selectElement.value,
                        selectedIndex = selectElement.selectedIndex,
                        selectedCurrentOption = selectElement.options[selectedIndex],
                        dataPrice = selectedCurrentOption.getAttribute('data-price');

                    document.querySelector('.price__regular span.money').innerText = '$ ' + dataPrice;
                }
                // End Updated additional product price for HiRise 3 + PlugBug Slim
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

        if (!addButton) return;

        var coming_soon_flag = false;
        var data_pre_order_flag = false;
        var data_pre_order_date = '';
        var variants_infoSelect = document.getElementById(`variants_info-${this.dataset.section}`);

        if (variants_infoSelect) {
            var variants_select_options = variants_infoSelect.querySelectorAll('option');
            if (variants_select_options.length) {

                if (this.currentVariant) {
                    var currentVariantId = this.currentVariant.id

                    variants_select_options.forEach(function (item, index) {
                        if (item.value == currentVariantId) {

                            if (item.getAttribute('data_pre_order_flag') == "YES") {
                                data_pre_order_flag = true;
                            }

                            if (item.getAttribute('data_pre_order_date') != undefined) {
                                if (item.getAttribute('data_pre_order_date').length) {
                                    var pre_order_dateEl = document.querySelector('.pre_order_date span');
                                    if (pre_order_dateEl) {
                                        pre_order_dateEl.innerHTML = item.getAttribute('data_pre_order_date');
                                        document.querySelector('.pre_order_date').classList.remove('hide');
                                    }
                                }
                            }

                            coming_soon_flag = item.getAttribute('data-coming_soon_flag');
                            var inventory_qty = +(item.getAttribute('data-inventory_quantity'));
                            var variant_qty_textEl = document.querySelector('.variant_qty_text');
                            if (variant_qty_textEl) {
                                if (inventory_qty > 0) {
                                    variant_qty_textEl.classList.remove('hide');
                                } else {
                                    variant_qty_textEl.classList.add('hide');
                                }
                                variant_qty_textEl.innerHTML = 'Only ' + inventory_qty + ' remaining!';
                            }
                        }
                    });
                }
            }
        }

        var buttonParent = addButton.closest('.double-button');
        var product_notifyMe__Wrapper = document.querySelector('.product_notifyMe__Wrapper');
        var notifyMeButton = document.querySelector('.product-main-info .product__info-container .swym-button-bar.swym-wishlist-button-bar.swym-inject.swym-isa-button-bar .swym-btn-container .swym-button');

        if (notifyMeButton && this.currentVariant) {
            if (this.currentVariant.available) {
                notifyMeButton.style.display = 'none';
            } else {
                notifyMeButton.style.display = 'block';
            }
        }

        if (product_notifyMe__Wrapper && this.currentVariant) {
            if (this.currentVariant.available) {
                product_notifyMe__Wrapper.classList.remove('show_btn');
            } else {
                product_notifyMe__Wrapper.classList.add('show_btn');
            }
        }

        if (disable) {
            if (buttonParent) {
                buttonParent.classList.add('disabled');
            }
            addButton.setAttribute('disabled', true);
            if (text) addButton.querySelector('span').textContent = text;

        } else {
            addButton.removeAttribute('disabled');

            if (data_pre_order_flag) {
                addButton.querySelector('span').textContent = window.strings.pre_order;
                var pre_order_dateEl = document.querySelector('.pre_order_date');

                if (pre_order_dateEl) {
                    pre_order_dateEl.classList.remove('hide');
                }

                var nav_buy_nowEl = document.querySelector('.nav-buy-now');
                if (nav_buy_nowEl) {
                    nav_buy_nowEl.classList.remove('hide_form');
                }

                var pre_order_propertyEl = document.querySelector('.pre_order_property');
                if (pre_order_propertyEl) {
                    var inputPropertyEl = document.createElement('input');
                    inputPropertyEl.setAttribute('id', 'pre_order_date_properties');
                    inputPropertyEl.setAttribute('type', 'hidden');
                    inputPropertyEl.setAttribute('name', 'properties[Pre Order]');
                    inputPropertyEl.setAttribute('data-additional_text', '' + window.strings.pre_order_date);
                    inputPropertyEl.value = data_pre_order_date;
                    pre_order_propertyEl.innerHTML = ' ';
                    pre_order_propertyEl.appendChild(inputPropertyEl);
                }

            } else {
                var pre_order_dateEl = document.querySelector('.pre_order_date');
                if (pre_order_dateEl) {
                    pre_order_dateEl.classList.add('hide');
                }
                addButton.querySelector('span').textContent = window.variantStrings.addToCart;
            }

            if (buttonParent) {
                buttonParent.classList.remove('disabled');
            }
        }
        if (!modifyClass) return;
    }

    setUnavailable() {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.querySelector('span').textContent = window.variantStrings.unavailable;
        document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    // AirFly: Flikity
    updateMedia() {
        return;
    }
}

customElements.define('variant-radios', VariantRadios);